import thLocale from 'element-ui/lib/locale/lang/th' //引入element语言包
const th = {
  posterPage: {
    title1:'คุณสมบัติการสมัครสมาชิกเร็ว ๆ นี้!',
    title2:'การต่ออายุการสมัครสมาชิกการอัพเกรดสิทธิพิเศษ!',
    title3:'ส่วนลดพิเศษสำหรับการต่ออายุ',
    title4:'รับรหัสแลกคุณสามารถปรึกษาผู้ขายที่ซื้ออุปกรณ์',
    title5:'คุณสมบัติประสบการณ์พิเศษ',
    function1:'รายละเอียดคุณลักษณะ:',
    function2:'ค่าธรรมเนียมการต่ออายุบริการพื้นฐาน (แปลภาษา, ผู้ช่วยประชุม, ผู้ช่วยอัจฉริยะ) ..',
    function3:'สมัครสมาชิกบริการเสริม (แปลออฟไลน์, เสียงและวิดีโอโทรแปล) ..',
  },
  RedemptionCodePage: {
    RedemptionCode: 'แลกรหัส',
    ValueAddedServices: 'บริการเสริม',
    UpgradedExperience: 'สิทธิประโยชน์พิเศษเพิ่มประสบการณ์อัพเกรด',
    OfflineTranslation: 'การแปลออฟไลน์',
    NoInternet: 'ไม่ต้องใช้เครือข่าย · การแปลทันที · ปลอดภัยและเชื่อถือได้',
    GoToSubscribe: 'ไปสมัครสมาชิก',
    AudioAndVideoCall: 'เสียง / วิดีโอคอล',
    RealTimeCall: 'การแปลเสียงแบบเรียลไทม์ · การเข้าถึงการสื่อสาร',
    BaseService: 'บริการพื้นฐาน',
    AIAssistant: 'ฟังก์ชัน: ล่ามแปลภาษา·ผู้ช่วยประชุม·ผู้ช่วย AI',
    LanguagesSetting:'การตั้งค่าภาษา',
    languages1:'ภาษาจีนตัวย่อ',
    languages2:'ภาษาจีนดั้งเดิม',
    languages3:'ภาษาไทย',
    languages4:'ญี่ปุ่น',
    languages5:'เกาหลี',
    languages6:'ภาษารัสเซีย',
    languages7:'สเปน',
    languages8:'ฝรั่งเศส',
    languages9:'เยอรมัน',
    languages10:'โปรตุเกส',
    languages11:'อิตาลี',
    languages12:'ตุรกี',
    languages13:'เวียดนาม',
    languages14:'ชาวอินโดนีเซีย',
    languages15:'ภาษาฮินดี name',
    languages16:'ภาษาอาหรับ',
    languages17:'ภาษาไทย',
    languages18:'เปอร์เซีย',
  },
  Login: {
    ToLogin: 'เข้าสู่ระบบ',
    PhoneLogin: 'หมายเลขโทรศัพท์มือถือ เข้าสู่ระบบ',
    EmailLogin: 'เข้าสู่ระบบกล่องจดหมาย',
    PhonePlaceholder: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
    EmailPlaceholder: 'Enter email',
    Code: 'รหัสยืนยัน',
    and: 'และ',
    BeforeText: 'ในขณะที่สร้างบัญชียินยอมและปฏิบัติตามในนามของคุณ',
    UserAgreement: 'ข้อตกลงผู้ใช้',
    privacy: 'นโยบายความเป็นส่วนตัว',
    errorMessage: 'ข้อผิดพลาดของรหัสยืนยัน',
    readTitle: 'อ่านและยอมรับข้อตกลงดังต่อไปนี้',
    readBefore: 'เพื่อรับประกันความปลอดภัยของข้อมูลส่วนบุคคลของคุณโปรดอ่านและยอมรับก่อน',
    cancel: 'การยกเลิก',
    agree: 'เห็นด้วยและดำเนินการต่อไป',
    error1:'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    error2:'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
    error3:'กรุณากรอกรหัสยืนยัน',
    success:'เข้าสู่ระบบสำเร็จ'
  },
  OffLinePage: {
    title: 'การแปลออฟไลน์',
    NoInternet: 'ไม่ต้องใช้เครือข่าย · การแปลทันที · ปลอดภัยและเชื่อถือได้',
    ServiceLife: 'ระยะเวลาการใช้งาน',
    forever: 'การใช้งานถาวร',
    describe: 'คำแนะนำการสมัครสมาชิก',
    describeItem1: '1. ฟังก์ชั่นการแปลแบบออฟไลน์เป็นค่าใช้จ่ายครั้งเดียวการใช้งานถาวรการใช้สิทธิ์ติดตามอุปกรณ์บลูทู ธ หากเปลี่ยนอุปกรณ์ต้องสมัครสมาชิกใหม่การแปลรหัสการแลกเปลี่ยนแบบออฟไลน์',
    describeItem2: '2. รหัสการอนุญาตไม่สามารถคืนเงินได้หลังจากการสมัครสมาชิก',
    describeItem3: '3. รองรับ 10 ภาษา: จีน, อังกฤษ, เยอรมัน, ญี่ปุ่น, เกาหลี, ฮินดี, ไทย, สเปน, ฝรั่งเศส, รัสเซีย',
    quantity: 'ปริมาณ',
    payType: 'วิธีการชำระเงิน',
    card: 'บัตรธนาคาร',
    wx: 'วีแชท',
    GooglePay: 'Google Pay',
    subscribe: 'สมัครสมาชิก',
    RMB: '¥',
    confirm:'ยืนยัน',
    cardNumber:'หมายเลขบัตร',
    periodOfValidity:'วันหมดอายุ',
    safetyCode:'รหัสความปลอดภัย',
    name:'ชื่อ-นามสกุล',
    yearAndMonth:'ปี / เดือน',
    message1:'จำนวนไม่สามารถเป็น 0',
    popTip:'เคล็ดลับที่อบอุ่น',
    popText1:'ขอให้ท่านผู้อ่านทำความเข้าใจอย่างถ่องแท้',
    popText2:'โปรโตคอลชำระเงินสำหรับการแปลออฟไลน์',
    popText3:'ฉันได้อ่านและยอมรับ',
    popText4:'ได้อ่านและยินยอม',
  },
  AudioVideoPage: {
    title: 'เสียง / วิดีโอคอล',
    RealTime: 'การแปลเสียงแบบเรียลไทม์ · การเข้าถึงการสื่อสาร',
    describe: 'คำแนะนำการสมัครสมาชิก',
    describeItem1: '1. ฟังก์ชั่นการแปลเสียงและวิดีโอสำหรับการเติมเงินเพื่อซื้อนาทีจำนวนนาทีจะคำนวณระยะเวลาจากการเชื่อมต่อการโทรสิทธิ์ตามหมายเลขบัญชีหากเข้าสู่ระบบบัญชีอื่นจะต้องเติมเงินใหม่',
    describeItem2: '2. การเชื่อมต่อและผูกอุปกรณ์ต่าง ๆ หลังจากเติมเงินหมายเลขบัญชีสามารถใช้งานได้ตามปกติ',
    describeItem3: '3. ฟังก์ชั่นการแปลเสียงและวิดีโอไม่สามารถคืนเงินได้หลังจากเติมเงิน',
    payType: 'วิธีการชำระเงิน',
    card: 'บัตรธนาคาร',
    wx: 'วีแชท',
    GooglePay: 'Google Pay',
    subscribe: 'สมัครสมาชิก',
    RMB: '¥',
    sale: 'ส่วนลด',
    confirm:'ยืนยัน',
    time1:'วินาที',
    time2:'นาที',
    time3:'ชั่วโมง',
    time4:'วัน',
    time5:'เดือน',
    time6:'ปี',
  },
  OffLineResult: {
    title1: 'การแปลออฟไลน์',
    title2: 'เสียง / วิดีโอคอล',
    title3: 'บริการพื้นฐาน',
    success: 'สมัครสมาชิกสำเร็จ',
    fail: 'การสมัครสมาชิกล้มเหลว',
    stock:'รหัสการแลกเปลี่ยน',
    saveTitle: 'บันทึกรหัสการแลกเปลี่ยนเพื่อไปที่ APP เพื่อแลกกับการใช้งาน',
    code: 'แลกรหัส',
    tip1: 'รหัสนี้ใช้สำหรับการแลกคุณสมบัติการแปลออฟไลน์เท่านั้น',
    tip2: 'รหัสนี้ใช้สำหรับการแลกรับแปลเสียง/วิดีโอคอลเท่านั้น',
    tip3: 'รหัสนี้ใช้เพื่อแลกรับสิทธิ์การต่ออายุบริการพื้นฐานเท่านั้น',
    save: 'บันทึก',
    time: 'ระยะเวลาการสมัคร:',
    copy: 'คัดลอก',
    copySuccess: 'คัดลอกสำเร็จ',
    loading:'กำลังโหลด',
    paySuccess:'การชำระเงินสำเร็จ'
  },
  RedemptionList: {
    title: 'รหัสแลกของฉัน',
    view: 'ดู',
    time: 'ระยะเวลาการสมัคร:',
  },
  MyRedemption: {
    title: 'รหัสแลกของฉัน',
    code: 'แลกรหัส',
    time: 'ระยะเวลาการสมัคร:',
    copy: 'คัดลอก',
    tip1: 'รหัสนี้ใช้สำหรับการแลกคุณสมบัติการแปลออฟไลน์เท่านั้น',
    tip2: 'รหัสนี้ใช้สำหรับการแลกรับแปลเสียง/วิดีโอคอลเท่านั้น',
    tip3: 'รหัสนี้ใช้เพื่อแลกรับสิทธิ์การต่ออายุบริการพื้นฐานเท่านั้น',
    save: 'บันทึก',
    success:"ความสำเร็จในการดำเนินงาน"
  },
  basePage:{
    error1:'ไม่ได้รับข้อมูลสินค้า',
    message1:'กรุณาเลือกสินค้า',
    title:'บริการพื้นฐาน',
    function:'ฟังก์ชัน: ล่ามแปลภาษา·ผู้ช่วยประชุม·ผู้ช่วย AI',
    describe: 'คำแนะนำการสมัครสมาชิก',
    describe1:'1. หลังจากการต่ออายุบริการพื้นฐานเช่นการแปลเอกสารเดียวกันผู้ช่วยประชุมและอื่น ๆ ความถูกต้องเป็นไปตามอุปกรณ์หากเปลี่ยนอุปกรณ์จะต้องต่ออายุ',
    describe2:'2. ไม่สามารถคืนเงินได้หลังจากต่ออายุบริการพื้นฐาน',
    payType: 'วิธีการชำระเงิน',
    card: 'บัตรธนาคาร',
    wx: 'วีแชท',
    GooglePay: 'Google Pay',
    subscribe: 'สมัครสมาชิก',
    RMB: '¥',
    sale: 'ส่วนลด',
    month:'เดือน',
    confirm:'ยืนยัน',
    month1:'1 เดือน',
    month2:'ครึ่งปี',
    month3:'1 ปี'
  },
  ...thLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default th;
